import { Component, Input, Output } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';


export type QueryInput = string;
export type SearchOutput = string;

@Component({
  selector: 'app-tag-search',
  templateUrl: './tag-search.component.html',
  styleUrls: ['./tag-search.component.scss']
})
export class TagSearchComponent {
  click$ = new Subject<string>();
  @Input() placeholder = '';
  @Input() query = '';
  @Output() search: Observable<SearchOutput> = this.click$.pipe(distinctUntilChanged());
}
